import { Injectable } from '@angular/core';
import { LanguageService } from 'src/app/share/services/language.service';
import { custom } from 'devextreme/ui/dialog';

@Injectable({
  providedIn: 'root',
})
export class CustomDialogService {
  constructor(private languageService: LanguageService) {}

  showCustomConfirm(message: string, isTranslated: boolean) {
    return custom({
      title: this.languageService.translate('confirmation'),
      messageHtml: isTranslated ? message : this.languageService.translate(message),
      buttons: [
        {
          text: this.languageService.translate('yes'),
          icon: 'check',
          stylingMode: 'contained',
          onClick: () => {
            return true;
          },
        },
        {
          text: this.languageService.translate('no'),
          icon: 'remove',
          stylingMode: 'contained',
          onClick: () => {
            return false;
          },
        },
      ],
    });
  }

  showCustomAlert(title: string, message: string) {
    return custom({
      title: title,
      messageHtml: message,
      buttons: [
        {
          text: this.languageService.translate('OK'),
          stylingMode: 'contained',
          onClick: () => {
            return true;
          },
        },
      ],
    });
  }
}
